export class Module {
    id = null;
    code = null;
    name = null;
    description = null;
    permissions = null;
}